import axios from 'axios'
import { SubmissionPayload } from '../containers/TradeForm/Types'
import { getAppConfigSetting } from '../utils'
import { BRAGGART_API } from './constants'

const postTransactionUrl = () => `${getAppConfigSetting('apiUrl')}${BRAGGART_API}`

export const postTransactionApi = (payload: SubmissionPayload) =>
  axios.post(postTransactionUrl(), [payload], { withCredentials: true })
